import React from "react";

import AppBar, { AppBarProps } from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface Props {
  title: string;
  onReadMore?(): void;
  sx?: AppBarProps["sx"];
}
const BannerView = ({ title, sx, onReadMore }: Props) => {
  return (
    <AppBar
      elevation={0}
      color="transparent"
      position="absolute"
      id="banner"
      sx={sx}>
      <Container
        sx={{
          px: "0 !important",
        }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          py={1.75}
          px={3}
          sx={{
            backgroundColor: "primary.main",
            borderRadius: 10,
          }}>
          <Typography
            variant="h5"
            sx={{
              flex: 1,
              color: "#fff",
              fontSize: "18px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {!!onReadMore && (
            <Button
              variant="text"
              sx={{
                fontSize: "1.125rem",
                minWidth: 0,
                padding: 0,
                color: "#fff",
                height: "auto",
                textDecoration: "underline",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={onReadMore}>
              Read more
            </Button>
          )}
        </Stack>
      </Container>
    </AppBar>
  );
};

export default BannerView;
